// extracted by mini-css-extract-plugin
module.exports = {"listOfItems":"_13l56J8qHcSwyY2z2f60Sk","item":"mZoFdjSovsZffJN2TxDCP","dot":"_2CgKX-A3V5FkwiDSqHI-Lv"};